<script>
	import { 
		linkBlog
	} from '../store.js';
	export let size = 12;

	async function getFeed() 
	{
		const url = `${atria.mainURL}/ShareLinkFix/blog.asp`;
		const response = await fetch(url, {
			method: 'GET',
			mode: 'cors',
			//headers: {'Content-type': 'text/xml;charset=ISO-8859-1'}
		});
		
		const raw = await response.text()
		const xml = new window.DOMParser().parseFromString(raw, 'text/xml');

		atria.xml = xml;
		let news = [];
		for (const item of xml.querySelectorAll('channel item')) {
			const media = item.querySelector('[medium="image"]');
			news.push({
				caption: item.querySelector('title').innerHTML,
				permalink: item.querySelector('link').innerHTML,
				media_url: media != null ? media.attributes.url.value : null,
				media_type: media != null ? 'image' : 'null'
			})
		}
		return news;
	}

	function activateSlick() {
		const selector = '.news'
		window.setTimeout(() => {
			jQuery('section.section-news').show();
			jQuery(selector).slick({
				infinite: true,
				speed: 1500,
				slidesToShow: 4,
				slidesToScroll: 1,
				autoplay: true,
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 850,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]            
			});
		}, 500);
	}

	$: feed = getFeed().then(news => {
		activateSlick();

		return news.slice(0, size);
	});
</script>

{#await feed}
{:then data}
<section class="section section-news mb-20" style="display: none;">
	<div class="container">
		<div class="header">
			<h2 class="title text-center">
				<a href="{$linkBlog}">Novidades | Notícias</a>
			</h2>
		</div>
		<div class="news">
			{#each data as post}
			<div class="post">
				{#if post.media_type == 'VIDEO'}
					<a href={post.permalink} target="_blank">
						<img onerror="ImageNotFound(this);" src="{post.thumbnail_url}" alt="{post.caption}"  />
						<div class="content">
							<!-- {post.caption} -->
						</div>
					</a>
				{:else}
					<a href={post.permalink} target="_blank">
						<img onerror="ImageNotFound(this);" src="{post.media_url}" alt="{post.caption}" />
						<div class="content flex flex-center text-center">
							<!-- {post.caption} -->
						</div>
					</a>
				{/if}
			</div>
			{/each}
		</div>
	</div>
</section>
{/await}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'
.news
	.post
		img
			height: 280px
			width: 100%
			object-fit: cover
		.content
			color: $color-accent
			padding: 10 15px
			border-bottom: 5px solid $color-primary
			min-height: 20px
</style>
